fx.ns("desktop.book.edition", class BookEditor extends fx.Component {
    
	constructor(data)
	{
		super(data);
	}

	get data()
	{
		return super.data;
	}

	set data(val)
	{
		if (typeof val == "number")
		{
			if (this.board)
				this.board.currentPageIndex = val;
		}
		else
			super.data = val;
	}

    get currentElement()
    {
        return this.board ? this.board.currentElement : null;
    }

    get currentArea()
    {
        return this.board ? this.board.currentArea : null;
    }

	contextMenu(e)
	{
        return [];
	}

	create()
	{
		super.create();

        this.board = new desktop.book.edition.BookBoard(this.data, desktop.book.edition.ComponentFactory, {backgroundColors : this.data.book.is3d, addText : this.data.book.is3d});
        this.addChild(this.board, {top:0,left:340,width:"100%",height:"100%"});

		if (this.data.book.is3d)
		{	
			let container3D = new fx.components.Box();
			this.icon3d = new fx.components.Image({data: fx.get("assets").iconButton3d, className : "icon3D"});
			container3D.addChild(this.icon3d, {top : 0, left : "center", width : 50, height : 50});
			this.board.addChild(container3D, {top : 20, left : 0, right : 90, height : 50});

			this.photoPanel = new desktop.common.panels.PhotosPanel(this.data, {automaticPlacingDisabled : true});
			this.addChild(this.photoPanel, {top:0,left:0,width:340,height:"100%"});
		}
		else
		{
			this.mediaTabs = new desktop.common.panels.MediaTabs( this.data);
			this.addChild(this.mediaTabs, {top:0,left:0,width:340,height:"100%"});
		}

		this.topBar = new desktop.common.actionbar.TopBar( this.data.book);
		this.addChild(this.topBar,  {top:20,right:25,width:100});

		this.actionBar = new desktop.common.actionbar.ActionBar( this.data);
		this.addChild(this.actionBar,  {top:"center",right:25,width:70});
		
		this.zoomWidget = new desktop.common.zoom.ZoomWidget(this.data, this.board, {preview : true});
		this.zoomWidget.visibleAtStart = false;
		this.addChild(this.zoomWidget, {bottom:20,right:35,width:255, height:43});

		this.viewWidget = new desktop.common.actionbar.ViewWidget(this.data, this.board);
		this.addChild(this.viewWidget, {bottom:20,right:35});

		this.topNotifications = new desktop.book.edition.TopNotifications(this.data);
		this.topNotifications.visibleAtStart = false;
		this.addChild(this.topNotifications, {top : 10, right : 25});
		
		this.dragger = new desktop.common.behaviour.ComponentDragger( this.data, this );

		if (fx.get("app") == "book" &&  fx.get("app-mode") != "touch" && !this.data.book.is3d)
		{
			this._optionSelectContainer = new fx.components.Box();
			this._optionSelectContainer.effect = "scroll";
			this._optionSelect = new fx.components.LinkButton({icon : fx.get("assets").editIcon, iconPosition : "left", className : "cover-select"});
			this._optionSelect.toolTip = fx.text("Cliquez pour changer la taille ou la couverture");
			this._optionSelectContainer.addChild( this._optionSelect , {width : "auto", top : 0, left : "center"});
			this.addChild( this._optionSelectContainer );
		}
	}

	onDisplayUpdated()
    {
		if (this._optionSelectContainer)
       		this._optionSelectContainer.viewport({ width : this.board.realWidth - this.topBar.realWidth - this.topBar.right(), height : 50, top : 0, left : this.board.left()});
    }

	onReady()
	{
		super.onReady();

		this.on("currentAreaChanged", this.onCurrentAreaChanged, this.board);
		this.on("currentElementChanged", this.onCurrentElementChanged, this.board);

		this.on("photo-extracted-started", this._onPhotoExtractedStarted, fx.service("MediasUploader") );
		this.on("photo-extracted-finished", this._onPhotoExtractedFinished, fx.service("MediasUploader") );

		this.on("cover-layout-applied", this._onCoverLayoutApplied, this.board);

		if (this.mediaTabs)
			this.mediaTabs.currentArea = this.board.currentArea;

		// drag / drop pictures
		this.on("dragover", this._onDrag, document);
		this.on("dragenter", this._onDrag, document);
		this.on("drop", this._onDrop, document);
		
		this.on("order", this._onOrder, this.topBar);
        this.on("exit", this._onExit, this.topBar);

		this.on("preview", this.onPreview, this.viewWidget);
		this.on("view", this.onView, this.viewWidget);
		this.on("zoom", this.onZoom, this.viewWidget);

		this.on("close", this.onZoomClosed, this.zoomWidget);

		this.on("scrolled", this._onScroll, this.board);

		if (this._optionSelect)
			this.on("click", this._onInfoPanel, this._optionSelect);

		this.on("updated", this._onZoomChanged, this.data.zoom);

		if (this.icon3d)
			this.on("click", this._displayWelcome, this.icon3d);
		

		if (this.data.book.is3d)
			this.delay(this._displayWelcome, 1000);
		else
		// case when opening a book created from a PDF
		if (!this.data.book.started && this.data.book.isCreatedFromFile)
            this.delay(this._showNewCreatedPopup, 1000);
        else
            this._setWelcomeTips();

		this.listenUpdates(this.data.book, true);
        this.listenUpdates(this.data.zoom, true);

		this._updateCoverLabel();

         // When creating book with IA, we create an empty book from the beginning.
		// Book is set to deleted. So if user cancels process before to reach preview, 
		// he will not see his books in his account. But if he reaches preview, this book
		// will be then displayed in his account.
		this.data.creation.deleted = 0;
    }

    _setWelcomeTips()
    {
        fx.service("WelcomeTips", {model :this.data, editor : this});
         
        let notifications = [];

        if (!this.data.book.started)
            notifications.push( {trigger:"choose-cover", forbidenComponentClass : "PopupPanel", component : this.mediaTabs, title :  fx.text("On Commence ?"), text :  fx.text("Choisissez la couverture<br>de votre album"), start : true } );

        notifications.push( {trigger:"photo-selected-empty", title :  fx.text("Pour ajouter une Photo"), text :  fx.text("Déplacez une photo depuis la galerie"), width : 350, height :100 } );
        notifications.push( {trigger:"first-updates", component : this.actionBar.undoButton, title :  fx.text("Au cas ou..."), text :  fx.text("Vous pouvez annulez vos<br>modifications ici") } );

        fx.service("WelcomeTips").notifications( notifications );    
    }

	_onCoverLayoutApplied()
	{
		this.mediaTabs.resetScroll();
	}

	_onScroll()
	{
		this._setCoverVisibility();
	}

	_setCoverVisibility()
	{
		if (this._optionSelectContainer)
			this._optionSelectContainer.toggle(this.board.scrollTop <= 30 && this.data.zoom.value == 100);
	}

	onPreview()
	{
		this.data.event("preview");
	}
	
	onView()
	{
		this.data.zoom.toggle();
	}

	onZoom()
	{
		this.data.zoom.zoomView();
		this.zoomWidget.show();
		this.viewWidget.hide();
	}

	onZoomClosed()
	{
		this.data.zoom.editionView();
		this.zoomWidget.hide();
		this.viewWidget.show();
	}

	_onInfoPanel()
    {
        this.data.event("info-panel");
    }

	_displayWelcome()
    {
        if (!this.data.book.started)
            this.popup(new desktop.book.edition.Welcome())

        fx.service("WelcomeTips", {model :this.data, editor : this});
         
        let notifications = [];
    
        notifications.push( {trigger:"photo-selected-empty", title :  fx.text("Pour ajouter une Photo"), text :  fx.text("Déplacez une photo depuis la galerie"), width : 350, height :100 } );
        notifications.push( {trigger:"first-updates", component : this.actionBar.undoButton, title :  fx.text("Au cas ou..."), text :  fx.text("Vous pouvez annulez vos<br>modifications ici") } );

        fx.service("WelcomeTips").notifications( notifications );    
    }
	
	_showNewCreatedPopup()
	{
		this.popup(new shared.popups.NewFileLostCoverPopup());
	}

	_onZoomChanged()
	{
		if (this.icon3d)
			this.icon3d.toggle(this.data.zoom.value < 100 || this.data.zoom.value > 100);

		this._setCoverVisibility();
	}

	show(callback)
	{
		super.show(callback);

		fx.set("mode", "edition");
	}

    _onOrder()
    {
        this.data.event("order");
    }

    _onExit()
    {
        this.data.event("exit-editor");
    }

	
	enable()
	{
		super.enable();

		this.board.enable();
	}

	disable()
	{
		super.disable();

		this.board.disable();
	}

	onCurrentAreaChanged(e)
	{
		if (this.mediaTabs)
			this.mediaTabs.currentArea = e.detail;

        this.trigger("current-area-changed");
	}

	onCurrentElementChanged(e)
	{
		if (this.mediaTabs)
			this.mediaTabs.selectTabForElement(e.detail);

        this.trigger("current-element-changed");
	}

	onDataEvent(e)
	{
		switch(e.type)
		{
			case "share-upload-started":
				this.popup(new shared.popups.SharedPhotosPopup(this.data));
				break;
			case "switch-photoPanel":
				this.mediaTabs.tabs.selectTab(this.mediaTabs.photoPanel);
				break;
			case "share-upload-validated":
				this.mediaTabs.selectFilter(0);
				break;
			case "currentAreaChanged" :
				this.onCurrentAreaChanged(e);
				break;
			case "custom-layout-creating" :
            	this.loading(true, fx.text("Sauvegarde de votre mise en page ..."));
				break;

			case "custom-layout-created" :
				this.mediaTabs.tabs.selectTab(this.mediaTabs.layoutPanel);
				this.loading(false);
				break;
				
			case "custom-layout-error" :
				this.loading(false);
				break;
		}
	}

	onDataUpdated(action)
	{
		if (action.impacts("formatid") || action.impacts("cover_option"))
            this._updateCoverLabel();

        if (action.model == this.data.zoom && action.impacts("value"))
        {
            this.mediaTabs.toggleClass("shadow", this.data.zoom.value > 100);
            this.topBar.toggle(this.data.zoom.value <= 100)
            this.actionBar.toggle(this.data.zoom.value <= 100)
        }
	}

	/** Drag / Drop pictures */

	_onDrag(e)
	{
		e.preventDefault();
		e.stopPropagation();
	}
	
	_onDrop(e)
	{
		e.preventDefault();
		e.stopPropagation();

		this._fileTypes = ["jpeg", "jpg", "png"];

		let dataTransfer =  e.dataTransfer;
		if( dataTransfer && dataTransfer.files.length) 
		{
			let files = [];

			// we filter here only valid image types
			for (let i = 0; i < dataTransfer.files.length; i++)
			{
				let file = dataTransfer.files[i];

				let ext = file["name"].toLowerCase().split('.').pop();

				if ( this._fileTypes.indexOf(ext) > -1 )
					files.push(file);
			}

			// no files, we do nothing
			if (files.length == 0)
				return;

			fx.service("MediasUploader").photoExtractor.process(files);
		}
	}

	_onPhotoExtractedStarted()
	{
		this.popup(new shared.popups.ExtractingPhotosPopup());
	}
	
	_onPhotoExtractedFinished()
	{
		// propose magic placement
		if(this.data && this.data.photos.length >= 10 && !this.data.book.photoPlacedAlready && !this.data.book.hasContent)
			this.data.book.event("propose-magic-placement", null, 1000);
			
	}

	_updateCoverLabel()
    {
		if (!this._optionSelect) return;

        let currentCover = this.data.book.covers.find({code : this.data.book.cover_option});
        let format = this.data.creationFormat;
        
        this._optionSelect.label = fx.text("Album") + " " + format.description + ", " + currentCover.label;
    }


});